import type { HTMLChakraProps } from '@chakra-ui/react-v2';
import { forwardRef, useMultiStyleConfig } from '@chakra-ui/react-v2';
import { chakra } from '@chakra-ui/react-v2';
import { useMemo } from 'react';

import {
  ActionPreviewProvider,
  type ActionPreviewMode,
} from '../ActionPreviewContext';
import {
  ActionPreviewStyles,
  ActionPreviewStylesProvider,
} from '../useActionPreviewStyles';

export type ActionPreviewProps = HTMLChakraProps<'div'> & {
  mode?: ActionPreviewMode;
};

/**
 * ActionPreview is a generic container for displaying action previews with a header, optional badge, and footer.
 */
export const ActionPreview: React.FC<ActionPreviewProps> = forwardRef<
  ActionPreviewProps,
  'div'
>(({ children, mode = 'pending', ...props }, ref) => {
  const actionPreviewStyles = useMultiStyleConfig(
    'ActionPreview',
  ) as ActionPreviewStyles;

  const value = useMemo(() => ({ mode }), [mode]);

  return (
    <ActionPreviewProvider value={value}>
      <ActionPreviewStylesProvider value={actionPreviewStyles}>
        <chakra.div
          sx={actionPreviewStyles.container}
          className="action-preview-container"
          {...props}
          ref={ref}
        >
          {children}
        </chakra.div>
      </ActionPreviewStylesProvider>
    </ActionPreviewProvider>
  );
});
ActionPreview.displayName = 'ActionPreview';
